import React, { useState } from "react";

export default function FAQ() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div>
      <div className="first_nav_hero_about">
        {/* ======== 1.1. header section ======== */}
        <header>
          <nav className="container navbar navbar-expand-lg ">
            <div className="container-fluid">
              {/* site logo */}
              <a className="nav-logo p-0" href="/">
                <img src="/assets/images/new_logo.svg" alt="logo" />
              </a>
              {/* navigation button  */}
              <button
                className="navbar-toggle"
                onClick={toggleNavbar}
                type="button"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                data-cf-modified-2a89ad8e51888e2ea151ec41-=""
              >
                <i className="fa-solid fa-bars" />
              </button>
              {/* navigation bar manu  */}
              <div
                className={`mobileNav collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarSupportedContent"
              >
                <ul className="navbar-nav d-flex justify-content-center align-items-center gap-lg-2 gap-md-2 gap-sm-2 gap-2 mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a className="nav-link active" href="/">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/aboutus">
                      About us
                    </a>
                  </li>
                  {/*
                    <li className="nav-item">
                      <a className="nav-link" href="/feature">
                        Solutions
                      </a>
                    </li>*/}
                  <li className="nav-item">
                    <a className="nav-link" href="/Contactus">
                      Contact Us
                    </a>
                  </li>

                  {/* <li className="nav-item">
                      <a className="nav-link" href="/FAQ">
                        FAQ's
                      </a>
                    </li>*/}
                  {/* <li className="dropdown">
                <a className="nav-link " href="#">
                  Pages <i className="fa-sharp fa-solid fa-sort-down" />
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="pricing.html">
                      Pricing
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="contact.html">
                      Contact
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="team.html">
                      Team
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="testimonials.html">
                      Testimonials
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="blogs.html">
                      Blogs
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="faq.html">
                      FAQ
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="404.html">
                      404
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="coming.html">
                      Coming Soon
                    </a>
                  </li>
                </ul>
              </li> */}
                  {/* <li className="nav-item">
                <a id="search-bar-bt" className="nav-link" href="#">
                  <i className="fa-solid fa-magnifying-glass" />
                </a>
              </li> 

                    <a className=" btn-hover4" href="#">
                      Create Account
                    </a>*/}

                  {/* <li
                className="nav-item"
                onclick="if (!window.__cfRLUnblockHandlers) return false; open_right_side()"
                data-cf-modified-2a89ad8e51888e2ea151ec41-=""
              >
                <a className="nav-link" href="#">
                  <i className="fa-sharp fa-solid fa-bars" />
                </a>
              </li> */}
                </ul>
              </div>
            </div>
          </nav>
          {/*============ navigation left slidebar================*/}
          <aside>
            <div id="mySidenav" className="sidenav">
              <div className="side-nav-logo d-flex justify-content-between align-items-center ps-4 pe-3">
                <figure className="navbar-brand">
                  <a href="/">
                    <img
                      src="/assets/images/new_logo.svg"
                      alt="img"
                      className="nav-logo"
                    />
                  </a>
                </figure>
                <div
                  className="closebtn"
                  onclick="if (!window.__cfRLUnblockHandlers) return false; closeNav()"
                  data-cf-modified-2a89ad8e51888e2ea151ec41-=""
                >
                  <i className="fa-solid fa-square-xmark side-bar-close-btn" />
                </div>
              </div>
              <ul>
                <li className="nav-item">
                  <a className="nav-link" aria-current="page" href="/">
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="about.html">
                    About
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/feature">
                    Solutions
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="pricing.html">
                    Pricing
                  </a>
                </li>
                <li className="nav-item">
                  <div
                    className="d-flex align-items-center justify-content-between pt-3"
                    id="slid-btn"
                  >
                    <button className="a-slid">Pages</button>
                    <i className="fa-solid fa-caret-down pe-4" />
                  </div>
                  <ul id="slid-drop" className="myst">
                    <li>
                      <a href="contact.html">Contact</a>
                    </li>
                    <li>
                      <a href="team.html">Team</a>
                    </li>
                    <li>
                      <a href="testimonials.html">Testimonials</a>
                    </li>
                    <li>
                      <a href="blogs.html">Blogs</a>
                    </li>
                    <li>
                      <a href="faq.html">FAQ</a>
                    </li>
                    <li>
                      <a href="404.html">404</a>
                    </li>
                    <li>
                      <a href="coming.html">Coming Soon</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </aside>
          {/*================== navigation drop search bar================*/}
          <div className="search" id="search-bar">
            <form className="d-flex nav-search">
              <input type="text" name="search" placeholder="Enter your text" />
              <button className="btn-hover1" type="submit">
                Search
              </button>
            </form>
            <button id="remove-btn">
              <i className="fa-solid fa-square-xmark " />
            </button>
          </div>
          {/*=================navigation Right slidebar==================*/}
          <section className="right-sidbar" id="right_side">
            <div className="d-flex justify-content-between align-items-center">
              {/* site logo */}
              <a className="p-0 " href="/">
                <img src="/assets/images/new_logo.svg" alt="logo" />
              </a>
              <button
                className="close_right_sidebar fa-solid fa-xmark"
                onclick="if (!window.__cfRLUnblockHandlers) return false; close_right_sade()"
                data-cf-modified-2a89ad8e51888e2ea151ec41-=""
              >
                {" "}
              </button>
            </div>
            <p className="mt-4 pb-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <a href="#" className="btn-hover1">
              Discover More
            </a>
            <hr />
            <h5 className="mt-4 mb-4">Connected details:</h5>
            <ul className="d-flex flex-column gap-3">
              <li>
                <a href="#">
                  {" "}
                  <i className="fa-solid fa-phone" />
                </a>
                <a href="#">
                  <span
                    className="__cf_email__"
                    data-cfemail="71081e04031f101c1431141c10181d5f121e1c"
                  >
                    [email&nbsp;protected]
                  </span>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fa-solid fa-envelope" />
                </a>
                <a href="#">+123-456-7890</a>
              </li>
              <li>
                <a href="#">
                  <i className="fa-solid fa-clock" />
                </a>
                <a href="#">
                  Office Hours: 8AM - 11PM Sunday - Weekend Day
                </a>
              </li>
            </ul>
            <span className="d-flex gap-4 mt-4">
              <a href="#" className="p-0">
                <i className="fa-brands fa-facebook" />
              </a>
              <a href="#" className="p-0">
                <i className="fa-brands fa-instagram" />
              </a>
              <a href="#" className="p-0">
                <i className="fa-brands fa-twitter" />
              </a>
            </span>
          </section>
        </header>
        {/* ======== End of 1.1. header section ========  */}
        {/* ======== 8.1. question section ========  */}
        <div className="container">
          <div className="ques-top-text">
            <h2>QUESTIONS</h2>
            <p>
              Find answers to commonly asked questions about our fintech services, including microfinancing, eligibility, and support.

            </p>
          </div>
          <div className="question-page">
            <h4>HOW TO USE?</h4>
            <p className="page-p">
              Our platform is designed to provide seamless financial solutions. Simply sign up, explore the services, and apply for the desired financial products.

            </p>
            <div className="question-collapes" data-aos="zoom-in">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h5 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How does microfinancing work?
                    </button>
                  </h5>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>
                        {" "}
                        Microfinancing provides small loans to individuals and businesses who lack access to traditional banking services. Borrowers can use these funds for various purposes, including business expansion and personal financial needs.

                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What types of businesses are eligible for this service?
                    </button>
                  </h5>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>
                        {" "}
                        Small and medium-sized enterprises (SMEs), startups, and individual entrepreneurs are eligible for our microfinancing services. Our platform supports a wide range of industries, including retail, agriculture, and manufacturing.

                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      How long does it take to receive funds?
                    </button>
                  </h5>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>
                        {" "}
                        The processing time depends on the type of loan and the documentation provided. Typically, funds are disbursed within 3 to 5 business days after approval.

                      </p>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h5 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      How can I contact with support?
                    </button>
                  </h5>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <p>
                        You can reach our support team via email at support@finkeypay.com or call our helpline at +123-456-7890. We also offer live chat support on our website.

                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordian-2nd">
            <h4 className="mt-lg-5 mt-md-3 mt-sm-1 mt-1">
              FREE CHARGES AND FEATURES
            </h4>
            <p className="page-p">
              Learn about our pricing model and features, ensuring complete transparency with no hidden charges.

            </p>
            <div className="accordion1" data-aos="zoom-in">
              <div className="accordion-item1">
                <div className="accordion-header1">
                  <h6>
                    {" "}
                    What are the fees associated with using our fintech services?
                  </h6>
                  <div className="accordion-toggle1 accordion-toggle-img active" />
                </div>
                <div className="accordion-content">
                  <p>
                    We offer competitive pricing with minimal fees. Loan processing fees, transaction fees, and interest rates are clearly outlined before you apply.

                  </p>
                </div>
              </div>
              <div className="accordion-item1">
                <div className="accordion-header1">
                  <h6>
                    {" "}
                    How are fees calculated for transactions and account management?
                  </h6>
                  <div className="accordion-toggle1 accordion-toggle-img" />
                </div>
                <div className="accordion-content">
                  <p>
                    Transaction fees are calculated based on the payment method and transaction amount. Account management fees are either fixed or percentage-based, depending on your chosen service plan.

                  </p>
                </div>
              </div>
              <div className="accordion-item1">
                <div className="accordion-header1">
                  <h6>
                    {" "}
                    Are there any hidden charges or additional fees that I should be
                    aware of?
                  </h6>
                  <div className="accordion-toggle1 accordion-toggle-img" />
                </div>
                <div className="accordion-content">
                  <p>
                    No, we maintain full transparency in our fee structure. All applicable charges are displayed before you proceed with any financial transaction.

                  </p>
                </div>
              </div>
              <div className="accordion-item1">
                <div className="accordion-header1">
                  <h6>
                    {" "}
                    What features and benefits are included in our fintech platform?
                  </h6>
                  <div className="accordion-toggle1 accordion-toggle-img" />
                </div>
                <div className="accordion-content">
                  <p>
                    Our platform offers secure transactions, easy loan applications, personalized financial insights, and 24/7 customer support to enhance your financial experience.

                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== End of 8.1. question section ========*/}
        {/* ======== 1.13. footer section ========  */}
        <footer className="position-relative">
          <div className="container">
            <h4 className="text-center">SUBSCRIBE OUR NEWSLETTER</h4>
            <p className="text-center pt-2 pb-3">Get latest News and Updates</p>
            <form
              className="d-flex align-items-center justify-content-center"
              id="footer-sub2"
            >
              {/* form Subscribe massage */}
              <div id="Succes-box2" />
              <div className="d-flex footer-search">
                <input
                  type="email"
                  name="search"
                  placeholder="Enter your Email"
                  required=""
                />
                <button type="submit" className="btn-hover1">
                  Subscribe
                </button>
              </div>
            </form>
            <div className="footer-logo text-center pb-lg-4 pb-md-3 pb-sm-2 pb-4">
              {/* footer logo  */}
              <a href="/">
                <figure>
                  <img src="/assets/images/new_logo.svg" alt="img" />
                </figure>
              </a>
            </div>
            <ul className="d-flex align-items-center justify-content-center">
              {/*<li>
              <a className="foot" href="/feature">Solutions</a>
            </li>*/}
              <li>
                <a className="foot" href="/Contactus">Contact Us</a>
              </li>
              <li>
                <a className="foot" href="/aboutus">About us</a>
              </li>
              {/*<li>
              <a className="foot" href="/FAQ">Faq</a>
            </li>*/}
            </ul>
            <hr />
            <div className="d-flex justify-content-center footer-nav-icon">
              {/* footer social icon  
            <div className="col-lg-3 col-md-3 d-flex align-items-center justify-content-md-start justify-content-sm-center justify-content-center">
              <div className="social-icon d-flex gap-2 justify-content-md-start justify-content-sm-center justify-content-center">
                <a href="#">
                  {" "}
                  <i className="fa-brands fa-facebook-f foot-facebook" />
                </a>
                <a href="#">
                  {" "}
                  <i className="fa-brands fa-twitter" />
                </a>
                <a href="#">
                  {" "}
                  <i className="fa-brands fa-instagram" />
                </a>
              </div>
            </div>
            */}
              {/* footer terms privacy  */}
              <div className="col-lg-6 col-md-6 d-flex justify-content-center align-items-center">
                <div className=" d-flex gap-3 p-2">
                  <a target="_blank" href="/assets/pdfs/Terms&Condition_Finkey.pdf" className="footer-terms">Terms &amp; Condition</a>
                  <a target="_blank" href="/assets/pdfs/Privacy_Policy_Finkey.pdf" className="footer-terms" >Privacy Policy</a>
                  <a target="_blank" href="/assets/pdfs/Refund_Policy_Finkey.pdf" className="footer-terms" >Refund Policy</a>
                </div>
              </div>
              {/* footer logo slider  */}
            </div>
            <hr />
            <div className="Copyright d-flex justify-content-between flex-wrap dir">
              <a className="footer-copyright">Copyright © 2024 FinkeyPay. All Right Reserved.</a>
              <a className="footer-copyright">FinkeyPay</a>
            </div>
          </div>
        </footer>
        {/* ======== End of 1.13. footer section ========  */}
      </div>

    </div>
  )
}
